export const hotspotAreas = {
  dashboard: {
    taskName: 'welcome.dashboardWalkthrough',
    hotspots: [
      'dashboard.progress',
      'dashboard.settings',
      'dashboard.account'
    ]
  },
  quickmenu: {
    taskName: 'welcome.menuWalkthrough',
    hotspots: [
      'quickmenu.quickmenu'
    ]
  },
  slider: {
    taskName: 'welcome.sliderWalkthrough',
    hotspots: [
      'slider.slider',
      'slider.resize',
      'slider.storeUrl',
      'slider.devices',
      'slider.editor'
    ]
  },
  analytics: {
    hotspots: [
      'analytics.exportorders',
      'analytics.analyticsapp',
      'analytics.exportAbandonedCarts'
    ]
  },
  customers: {
    hotspots: [
      'customers.exportcustomers'
    ]
  },
  header: {
    taskName: 'welcome.dashboardHeaderImage',
    hotspots: [
      'header.dashboardimage'
    ]
  },
  settings: {
    hotspots: [
      'settings.addresses'
    ]
  },
  founderguide: {
    hotspots: [
      'founderguide.progressbar'
    ]
  }
};


// WEBPACK FOOTER //
// ./src/app/admin/stores/OnboardingStore/onboardingData.js